import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import "./nav.css";

export default function Nav() {
  const navigate = useNavigate();
  const { user, logout, isAdmin } = useAuth();

  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setUserMenuOpen(false);
  };

  return (
    <nav className="top-nav">
      <div className="nav-inner">
        {/* Brand */}
        <NavLink
          to="/"
          className="nav-brand"
          style={{ textDecoration: "none" }}
          onClick={closeMobileMenu}
        >
          <div className="nav-brand-logo">M</div>

          <div className="nav-brand-text">
            <span className="nav-brand-title">Mulu Health PLC</span>

            <span className="nav-brand-sub">
              AHC PHC Capacity Assessment V5
            </span>
          </div>
        </NavLink>

        {/* Mobile hamburger */}
        <button
          type="button"
          className={`nav-mobile-toggle ${mobileMenuOpen ? "open" : ""}`}
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation */}
        <div className={`nav-links ${mobileMenuOpen ? "mobile-open" : ""}`}>
          <NavLink
            to="/"
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
            end
            onClick={closeMobileMenu}
          >
            Home
          </NavLink>

          <NavLink
            to="/assessment/new"
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
            onClick={closeMobileMenu}
          >
            New Assessment
          </NavLink>

          <NavLink
            to="/history"
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
            onClick={closeMobileMenu}
          >
            History
          </NavLink>

          <NavLink
            to="/reports/new"
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
            onClick={closeMobileMenu}
          >
            New Report
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
            onClick={closeMobileMenu}
          >
            About
          </NavLink>

          {isAdmin && (
            <NavLink
              to="/admin/users"
              className={({ isActive }) =>
                `nav-link${isActive ? " active" : ""}`
              }
              onClick={closeMobileMenu}
            >
              Users
            </NavLink>
          )}

          {/* User dropdown */}
          <div
            className={`nav-user-menu ${userMenuOpen ? "open" : ""}`}
            onMouseEnter={() => setUserMenuOpen(true)}
            onMouseLeave={() => setUserMenuOpen(false)}
          >
            <button
              type="button"
              className="nav-user-trigger"
              onClick={() => setUserMenuOpen((prev) => !prev)}
              aria-expanded={userMenuOpen}
            >
              <span className="nav-user-avatar">
                {(user?.fullName || "U").charAt(0).toUpperCase()}
              </span>

              <span className="nav-user-info">
                <span className="nav-user-name">
                  {user?.fullName || "Signed in"}
                </span>

                <span className="nav-user-role">
                  {user?.role === "superadmin"
                    ? "Superadmin"
                    : user?.role || "user"}
                </span>
              </span>

              <span className="nav-user-chevron">⌄</span>
            </button>

            <div className="nav-user-dropdown">
              <div className="nav-dropdown-header">
                <span className="nav-dropdown-name">
                  {user?.fullName || "Signed in"}
                </span>

                <span className="nav-dropdown-role">
                  {user?.role === "superadmin"
                    ? "Superadmin"
                    : user?.role || "user"}
                </span>
              </div>

              <div className="nav-dropdown-divider" />

              <NavLink
                to="/profile"
                className="nav-dropdown-item"
                onClick={closeMobileMenu}
              >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                Profile & Security
              </NavLink>

              <button
                type="button"
                className="nav-dropdown-item"
                onClick={() => {
                  closeMobileMenu();
                  setUserMenuOpen(false);
                  window.dispatchEvent(new CustomEvent("open-user-guide"));
                }}
              >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
                User Guide
              </button>

              <div className="nav-dropdown-divider" />

              <button
                type="button"
                className="nav-dropdown-logout"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
